import _ from 'underscore';
import jstz from 'jstimezonedetect';
import moment from 'moment-timezone';
import UAParser from 'ua-parser-js';
import deviceDetect from 'device-detect';
import abbrs from './timezone-abbrs';

const uaParser = new UAParser();
const dd = deviceDetect();
const tz = jstz.determine();
const ua = uaParser.getResult();

// eslint-disable-next-line func-names
moment.fn.zoneName = function() {
  let abbr = this.zoneAbbr();
  if (_.isArray(abbrs[abbr])) {
    if (abbr === 'PST') {
      let currentLocation;
      _.each(abbrs[abbr], (i) => {
        currentLocation = tz.name().substring(0, tz.name().lastIndexOf('/'));
        if (i.location.indexOf(currentLocation) !== -1) {
          abbr = i.tzname;
        }
      });
    } else {
      _.each(abbrs[abbr], (i) => {
        if (
          i.offset.indexOf(
            moment()
              .tz(tz.name())
              .format('Z')
          ) !== -1
        ) {
          abbr = i.tzname;
        }
      });
    }
  } else {
    abbr = abbrs[abbr] || abbr;
  }
  return abbr;
};

const user = {
  agent: window.navigator.userAgent,
  timezone: {
    location: tz.name(),
    name: moment()
      .tz(tz.name())
      .format('zz'),
    offset: moment()
      .tz(tz.name())
      .format('Z')
  },
  browser: {
    name: ua.browser.name,
    version: ua.browser.version,
    engine: ua.engine.name
  },
  device: {
    // ua-parser-js has type undefined for desktop devices
    // but correctly detects everything else, that is why we
    // need a fallback for 'desktop' and to device-detect here
    name: ua.device.model || dd.device,
    type: ua.device.type || 'desktop'
  },
  os: {
    name: ua.os.name,
    version: ua.os.version
  }
};

export default user;
